exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.red {\n\tcolor: #f00;\n}\n", "", {"version":3,"sources":["/Users/ryanblaind/Dropbox/Work/dev/shopify-modern/src/views/Error404View.vue?df9c4342"],"names":[],"mappings":";AAwBA;CACA,YAAA;CACA","file":"Error404View.vue","sourcesContent":["/*\n\t404 Error component\n\n\tshown when 404 error is received\n*/\n\n<template>\n\t<div>\n\t\t<h1 class=\"red\">404 error !!</h1>\n\t</div>\n\n</template>\n\n<script>\n\texport default {\n\n\t\tdata () {\n\t\t\treturn {\n\t\t\t}\n\t\t},\n\t}\n</script>\n\n<style>\n\t.red {\n\t\tcolor: #f00;\n\t}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61edc12c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Error404View.vue
// module id = 35
// module chunks = 0